import React, {Fragment} from "react";
import avatarImg from "../../../../assets/img/demo/player-avatar-1.png";
import ModalBase from "../../modals/ModalBase";
import Participants from "../../general/participants/Participants";

import {Button, Form} from "react-bootstrap";
import SVG from "react-inlinesvg";
import closeIcon from "../../../../assets/svg/actions/icn-close.svg";
import icn_delete from "../../../../assets/svg/actions/icn-delete-20px-blue.svg";
import icon_upload_avatar from "../../../../assets/svg/actions/icn-upload-avatar.svg";
import icon_upload_avatar_dark from "../../../../assets/svg/actions/icn-upload-avatar--dark.svg";

import "../../../../assets/sass/components/messages/group-info-modal.scss";
import Participant from "../../general/participants/Participant";
import Tools from "../../../../Tools";
import Icon from "../../Icon";
import { ThemeContext } from "../../../layouts/ThemeProvider";
import DropAndCropModal from "../../images/DropAndCropModal";

class GroupInfoModal extends ModalBase {

    state = {
        participants: Array.from(Array(10).keys())
            .map((item, index) => ({
                key: index,
                avatar: avatarImg,
                name: 'Calvin Cooper',
                info: 'Scout | Canberry Football Club',
                selected: false,
            })),
        owner: {
            key: Tools.generateToken(5),
            avatar: avatarImg,
            name: 'You',
            info: 'Scout | Canberry Football Club',
            selected: false,
        },
        group: {
            edit: false,
            name: "Group Name 1",
            new_name: ""
        },

        groupInfoCropModalShow: false,
        groupImage: null,
    };

    switchToEditGroup = (event) => {
        event.preventDefault();
        this.setState({
            group: {
                ...this.state.group,
                new_name: this.state.group.name,
                edit: true
            }
        })
    }

    saveGroupName = (event) => {
        event.preventDefault();
        if(this.state.group.name)
        this.setState({
            group: {
                edit: false,
                name: this.state.group.new_name ? this.state.group.new_name : this.state.group.name,
                new_name: "",
            }
        })
    }

    groupName = () => {
        return (
            <Fragment>
                <h2>{this.state.group.name}</h2>
                <Button variant="link" onClick={this.switchToEditGroup}>Edit Name</Button>
            </Fragment>
        )
    }

    onInputGroupName = (event) => {
        event.preventDefault();
        this.setState({
            group: {
                ...this.state.group,
                new_name: event.target.value,
            }
        })
    }

    groupNameEdit = () => {
        return (
            <Fragment>
                <input className="input input-sm input-flat" value={this.state.group.new_name} onInput={this.onInputGroupName}/>
                <Button variant="link" onClick={this.saveGroupName}>Save</Button>
            </Fragment>
        )
    }

    handleGroupInfoCropModalClose = () => {
        this.setState({
            groupInfoCropModalShow: false
        })
    }

    handleGroupInfoCropModalOpen = (event) => {
        event.preventDefault();
        this.setState({
            groupInfoCropModalShow: true
        })
    }

    setModalShow = () => {
        return this.state.groupInfoCropModalShow ? false : this.props.show;
    }

    handleUploadImage = (uploadedImage) => {
        this.setState({ groupImage: uploadedImage, groupInfoCropModalShow: false });
    }

    setGroupImage = () => {
        return this.state.groupImage ? (
            <img src={this.state.groupImage} alt="Group Name 1" className="group-avatar"/>
        ) : (
            <div className="group-avatar-default">
                {this.state.group.name.match(/\b\w/g).slice(0, 2).join('')}
            </div>
        )
    }

    renderHeaderWrapper = () => {}
    renderFooterWrapper = () => {}
    renderBody = () => {
        const theme = this.context;
        const uploadIcon = theme === 'dark' ? icon_upload_avatar_dark : icon_upload_avatar;
        return (
            <div className="group-info-modal-wrapper">
                <div className="header-wrapper">
                    <Button variant="link" className="close-modal" onClick={this.closeModal}><SVG src={closeIcon}/></Button>
                    <div className="group-avatar">
                        {this.setGroupImage()}
                        <Icon svg={uploadIcon} className="upload-avatar" onClick={this.handleGroupInfoCropModalOpen}/>
                    </div>
                </div>
                <div className="group-name">
                    {this.state.group.edit ? this.groupNameEdit() : this.groupName()}
                </div>
                <div className="creator">
                    <div className="creator-header">
                        <span>Created By</span>
                        <time>On 12/31/2020</time>
                    </div>
                    <Participant data={this.state.owner} hasToggleIcon={false}/>
                </div>
                <div className="participants-members">
                    <h3>Participants ({this.state.participants.length})</h3>
                    <Participants data={this.state.participants} hasToggleIcon={false} fixedIcon={icn_delete}/>
                </div>
            </div>
        )
    }

    renderExtraContent = () => {
        return (
            <DropAndCropModal
                headerTitle="Change Group Photo"
                btnText="Set Group Photo"
                dropProps={{title: "Drag a group photo here"}}
                show={this.state.groupInfoCropModalShow}
                onHide={this.handleGroupInfoCropModalClose}
                onSubmit={this.handleUploadImage}
            />
        )
    }

    static contextType = ThemeContext

    static defaultProps = {
        className: "group-info-modal",
        size: "md",
    };
};

export default GroupInfoModal;